import React, { useState, useEffect } from "react";
import Avatar from "../../../../components/ui/avatar/Avtar";
import CKEditorComponent from "../../../../components/finalForms/ui/inputs/ckEditor/CKEditor";
import "./CommentsTest.scss";
import IconButton from "../../../../components/ui/iconbutton/IconButton";
import Buttons from "../../../../components/ui/button/Buttons";
import { useAddTaskCommentMutation, useDeleteTaskCommentMutation, useLazyGetAllTaskCommentQuery } from "../../../../app/services/taskCommentsAPI";
import ToastService from "../../../../services/toastService/ToastService";
import { useSelector } from "react-redux";
import { editorConfig } from "../../../../components/finalForms/ui/inputs/ckEditor/CkEditorConfig";
import NoRecordFound from "../../../../components/ui/noRecordFound/NoRecordFound";
import SwalAlert from "../../../../services/swalService/SwalService";
import Iconify from "../../../../layouts/components/iconify/iconify";
import { DropdownWrapper } from "../../../../components/ui/dropdownwrapper/DropdownWrapper";
import CenterModel from "../../../../components/ui/centerModel/CenterModel";
import EditComments from "./editComments/EditComments";
import formatDate from "../../../../lib/formatDate";
import { useImperativeHandle } from "react";
import { forwardRef } from "react";

const Comments = ({ taskId, projectId, onSuccess }, ref) => {

  const { user } = useSelector((state) => state.auth);
  const userID = user.userId;
  const [newComment, setNewComment] = useState("");
  const [isOpen, setIsOpen] = useState(true);
  const [comments, setComments] = useState([]);
  const { confirm, error } = SwalAlert();
  const [commentData, setCommentData] = useState();
  const [showModal, setShowModal] = useState(false);

  const [getAllTaskComment, { isFetching: isTaskCommentFetching, isSuccess: isTaskComment, data: TaskCommentData }] = useLazyGetAllTaskCommentQuery();
  const [addTaskComment, { isSuccess: isCommentAdded, data: addTaskCommentData }] = useAddTaskCommentMutation();

  const [deleteEditTaskComment, {
    isSuccess: isDeleteSuccess,
    data: isDeletData
  },] = useDeleteTaskCommentMutation();

  useEffect(() => {
    if (isDeleteSuccess && isDeletData) {
      ToastService.success(isDeletData.errorMessage);
      getAllTaskComment(taskId);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDeleteSuccess, isDeletData]);

  // Toggle comment box visibility
  const toggleMessageBox = () => {
    setIsOpen(!isOpen);
  };

  // Fetch comments when taskId changes
  useEffect(() => {
    if (taskId) {
      getAllTaskComment(taskId);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [taskId, onSuccess]);

  // Process fetched comments
  useEffect(() => {
    if (!isTaskCommentFetching && isTaskComment && TaskCommentData) {
      const transformedComments = TaskCommentData?.map((task) => ({
        id: task.taskCommentId,
        user: task.commentBy,
        text: task.commentText,
        date: task.commentDate,
        userId: task.userId
      }));
      setComments(transformedComments);
    }
  }, [isTaskCommentFetching, isTaskComment, TaskCommentData]);

  useEffect(() => {
    if (isCommentAdded && addTaskCommentData) {
      if (addTaskCommentData.errorMessage.includes("exists")) {
        ToastService.warning(addTaskCommentData.errorMessage);
      } else {
        getAllTaskComment(taskId);
        ToastService.success("Comment added successfully!");
        toggleMessageBox();
        // onsuccess?.();
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCommentAdded, addTaskCommentData]);

  const handleDeleteClick = (comment) => {
    if (comment.id) {

      confirm(
        "Delete?",
        "Are you sure you want to delete this Comment?",
        "Delete",
        "Cancel"
      ).then((confirmed) => {
        if (confirmed) {
          deleteEditTaskComment(comment.id);
        }
      });
    }
  };

  const onEditAction = (comment) => {
    setCommentData(comment);
    setShowModal(true);
  };

  const closePopup = () => {
    setShowModal(false);
  };

  const onSuccessPopup = () => {
    setShowModal(false);
    getAllTaskComment(taskId);
  };

  const handleCKEditorChange = (newData) => setNewComment(newData);

  const handleSubmit = () => {
    const request = {
      userId: userID, taskId, projectId, commentText: newComment
    };
    if (request.commentText === "") {
      error("please enter your comment", "Validation Failed!");
    } else {
      addTaskComment(request);
    }
  };

  useImperativeHandle(ref, () => ({
    refreshComments: () => {
      if (ref) {
        getAllTaskComment(taskId);
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }), [])

  return (
    <div className={`editmytask-comments ${!isOpen ? "comment-box-full" : ""}`}>
      <div className="editmytask-comment-section">
        <div className={`editmytask-comment-body ${!isOpen ? "comment-body-full" : ""}`}>
          {comments?.length > 0 ? (
            comments.map((comment) => (
              <div key={comment.id} className={`editmytask-comment-message ${comment.userId === userID ? 'outgoing-message' : ''}"`}>
                <div className="editmytask-comment-avatar">
                  <Avatar alt={comment.user} shape="circle" size="medium" />
                </div>
                <div className="editmytask-comment-content">
                  <div className="editmytask-comment-details">
                    <div className="editmytask-comment-username">{comment.user}</div>
                    <div className="editmytask-comment-time">
                      {comment.date && formatDate(comment.date, "DD MMM, YYYY hh:mm A")}
                      {comment.userId === userID ? (
                        <div className="address-actions">
                          <DropdownWrapper
                            direction="left"
                            className="action-button-dropdown"
                            toggleElement={
                              <button className="customer-more-btn">
                                <Iconify icon="flowbite:dots-vertical-outline" />
                              </button>
                            }
                          >
                            <button onClick={() => onEditAction(comment)}>
                              <Iconify icon="line-md:pencil" />
                              Edit
                            </button>
                            <button onClick={() => handleDeleteClick(comment)}>
                              <Iconify icon="material-symbols:close-rounded" />
                              Remove
                            </button>
                          </DropdownWrapper>
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="border-line"></div>
                  <div className="comment-description" dangerouslySetInnerHTML={{ __html: comment.text }}></div>

                  {/* Add Edit/Delete Actions for User's Own Comments */}

                </div>
              </div>
            ))
          ) : (
            <NoRecordFound message="No comments available" />
          )}
        </div>
        <div>
          {showModal && (
            <CenterModel
              showModal={showModal}
              handleToggleModal={closePopup}
              modalTitle="Edit your Comment"
              modelSizeClass="w-40"
            >
              <div className="row">
                <EditComments
                  comment={commentData}
                  onClose={closePopup}
                  onSuccessPopup={onSuccessPopup} />
              </div>
            </CenterModel>
          )}
        </div>
        <IconButton
          variant="contained"
          icon={isOpen ? "mdi:close" : "tabler:message"}
          shape="circle"
          className={isOpen ? "floating-message-btn" : "floating-message-btn-bottom"}
          size="medium"
          onClick={toggleMessageBox}
        />
      </div>
      <div className={`task-editor comment-box-task-editor txt-editer-mr ${isOpen ? "comment-collapse" : ""}`}>
        <Avatar src="" alt={user.userName} size="medium" shape="circle" />
        <CKEditorComponent
          data={newComment}
          isdisable={false}
          onCKEditorChange={handleCKEditorChange}
          config={{ ...editorConfig, placeholder: "Please Enter Task Comments", }}
        />
        <div className="comment-post">
          <Buttons buttonTypeClassName="post-btn" buttonText="Post" onClick={handleSubmit} />
        </div>
      </div>
    </div >
  );
};

export default forwardRef(Comments);
